// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../isMatch/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var isMatchWithOptions = convertToFP(fn, 3);
export default isMatchWithOptions;